import {fabric} from "fabric-with-gestures";

export default {
  mounted() {
    bus.$on('addWall', this.addWall)
    bus.$on('addCircle', this.addCircle)
    bus.$on('addText', this.addText)
    bus.$on('addEllipse', this.addEllipse)
  },
  methods:{
    addEllipse(){
      let object =  new fabric.Ellipse({
        left: this.globalPosition.left,
        top: this.globalPosition.top,
        width: 15,
        originX: 'center',
        perPixelTargetFind:true,
        originY: 'center',
        objectCaching: false,
        strokeWidth: 7,
        fill: '#dddddd',
        rx: 50,
        ry: 90
      });
      this.canvas.add(
       object
      )
      this.canvas.renderAll();
    },
    addWall() {
      let object =   new fabric.Rect({
        left: this.globalPosition.left,
        top: this.globalPosition.top,
        width: 15,
        height: 400,
        fill: '#dddddd',
        originX: 'center',
        originY: 'center',
        perPixelTargetFind:true,
      });

      object.setControlsVisibility({
        tr: true,
        bl: false,
        tl: false,
        br:false,
        ml: true,
        mt: true,
        mr: true,
        mb: true,
        mtr: true
      })
      this.canvas.add(
        object
      )
      this.canvas.renderAll();
    },
    addCircle() {

      let object = new fabric.Circle({
        left: this.globalPosition.left,
        top: this.globalPosition.top,
        width: 15,
        radius: 40,
        originX: 'center',
        originY: 'center',
        objectCaching: false,
        perPixelTargetFind:true,
        strokeWidth: 7,
        fill: '#dddddd',
        _controlsVisibility : {
          tr: true,
          bl: false,
          tl: false,
          br: false,
          ml:false,
          mt: false,
          mr: false,
          mb: false,
          mtr: true
        }
      });

      this.canvas.add(
        object
      )
      this.canvas.renderAll();
    },
    addText() {

      let text = new fabric.Text('Текст', {
        left: this.globalPosition.left,
        top: this.globalPosition.top,
        fill: 'black',
        objecttype: 'text',
        perPixelTargetFind:false
      });

      text.setControlsVisibility({
        tr: true,
        bl: false,
        tl: false,
        br: false,
        ml: false,
        mt: false,
        mr: false,
        mb: false,
        mtr: true
      })

      this.canvas.add(text)
      this.canvas.renderAll();
    }
  }
}
